

















































import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/AudienceCreativeWizard/WizardNavbar'
import WizardNavigation from '@ui/AudienceCreativeWizard/WizardNavigation'
import FormField from '@ui/FormBuilder/FormField'

settings =
  name: 'OverviewStep'

  resources:
    teams:
      resourceName: 'suppliers'
      slug: 'suppliers/:wizard.supplierId/suppliers'

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      FormField,
    }

    data: ->
      form: @wizard.audienceCreativeData
      selectedSupplierIds: []

    computed:
      inputPropsForTeamSelect: ->
        limit: 1
        options: @teams || []
        context:
          supplierId: @wizard.supplierId

    methods:
      hiChangeSelectedSupplierIds: (supplierIds) ->
        @form.supplier_id = supplierIds[0]

export default VueOptions.vue settings
